import React from 'react'
import PropTypes from 'prop-types'

import { withStyles } from '@material-ui/core/styles'
import {
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core'

class UnitFormDialog extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    unit: PropTypes.object,
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  }

  static defaultProps = {
    unit: {
      sku: '',
      serial: '',
      community_id: '',
      name: '',
      location: { address: '' },
    },
  }

  static styles = {}

  state = { ...this.props.unit }

  onUnitSKUChange = (e) => {
    this.setState({ sku: e.currentTarget.value })
  }

  onUnitSerialChange = (e) => {
    this.setState({ serial: e.currentTarget.value })
  }

  onUnitCommunityIdChange = (e) => {
    let val = parseInt(e.currentTarget.value, 10)
    if (Number.isNaN(val)) {
      val = 0
    }
    this.setState({ community_id: val })
  }

  onUnitNameChange = (e) => {
    this.setState({ name: e.currentTarget.value })
  }

  onUnitAddressChange = (e) => {
    this.setState({ location: { address: e.currentTarget.value } })
  }

  onSubmit = () => {
    const unit = this.state
    if (unit.community_id === '') {
      unit.community_id = 0
    }
    this.props.onSubmit(unit)
    this.props.onClose()
  }

  render() {
    const { title, onClose } = this.props

    return (
      <Dialog open onClose={onClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">{title}</DialogTitle>

        <DialogContent>
          <div>
            <TextField label="Unit Name" value={this.state.name} onChange={this.onUnitNameChange} />
          </div>
          <div>
            <TextField
              label="Community ID"
              value={this.state.community_id || ''}
              onChange={this.onUnitCommunityIdChange}
            />
          </div>
          <div>
            <TextField label="SKU" value={this.state.sku} onChange={this.onUnitSKUChange} />
          </div>
          <div>
            <TextField label="Serial" value={this.state.serial} onChange={this.onUnitSerialChange} />
          </div>
          <div>
            <TextField label="Address" value={this.state.location.address} onChange={this.onUnitAddressChange} />
          </div>
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose} variant="contained" color="secondary">
            Cancel
          </Button>
          <Button onClick={this.onSubmit} variant="contained" color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default withStyles(UnitFormDialog.styles)(UnitFormDialog)
